import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import axios from "../../core/api/axiosClient";

const initialState: any = {
  attemptedRoute: "",
  unsavedDetectorInitiated: false,
  isLoading: false,
  error: null,
};

export const routeStateSlice = createSlice({
  name: "routeState",
  initialState,
  reducers: {
    setAttemptedRoute(state, action) {
      state.attemptedRoute = action.payload;
    },
    setUnsavedDetectorInitiated(state, action) {
      state.unsavedDetectorInitiated = action.payload;
    }
  },
  extraReducers: (builder) => {},
});

export const {
  setAttemptedRoute,
  setUnsavedDetectorInitiated,
} = routeStateSlice.actions;

export default routeStateSlice.reducer;
